import { useColorScheme } from '@mui/material/styles';

export type ThemeMode = 'system' | 'light' | 'dark';

type UseThemeModeReturn = {
  /** What the user picked. `undefined` on first render before hydration. */
  mode: ThemeMode | undefined;
  /** What's actually applied right now. `undefined` on first render. */
  resolvedMode: 'light' | 'dark' | undefined;
  setMode: (mode: ThemeMode) => void;
};

export function useThemeMode(): UseThemeModeReturn {
  const { mode, systemMode, setMode } = useColorScheme();

  const resolvedMode = mode === 'system' ? systemMode : mode;

  return {
    mode,
    resolvedMode,
    setMode
  };
}
